export const PHOTO_MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const PHOTO_ACCEPT = "image/jpeg,image/png,image/webp";
export const PHOTO_SIZE_ERROR = "La photo est trop volumineuse. Taille maximale : 10 Mo.";
export const PHOTO_TYPE_ERROR = "Format de photo non pris en charge. Utilisez JPEG, PNG ou WebP.";

export function validatePhotoFile(file) {
    if (!file) return null;
    if (file.size > PHOTO_MAX_UPLOAD_BYTES) return PHOTO_SIZE_ERROR;
    if (![
        "image/jpeg",
        "image/png",
        "image/webp",
    ].includes((file.type || "").toLowerCase())) return PHOTO_TYPE_ERROR;
    return null;
}
